import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import '@/sass/fonts.scss'
import '@/sass/mdi.scss'

Vue.config.productionTip = false

import('./main.sass');

import i18n from '@/plugins/i18n'

import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/es')
moment.locale(i18n.locale === 'en' ? 'en' : 'es')
Vue.use(VueMoment, {
  moment
})

import {accountMixin} from '@/mixins/baseGlobalMixin'
import {planMixin} from '@/mixins/planMixin'

Vue.mixin(accountMixin)
Vue.mixin(planMixin)

import stackDirective from '@/directives/stack'
Vue.directive('stack', stackDirective)

import './utils/Filters'

import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import { defineCustomElements } from '@ionic/pwa-elements/loader';
defineCustomElements(window);

import './registerServiceWorker'

if (process.env.VUE_APP_ENV === 'production') {
  console.log = function () {};
}

if (process.env.VUE_APP_BETA === 'true') {
  document.title = `[BETA] ${document.title}`
}

import { setupErrorReporting } from '@/utils/ErrorReporter'
setupErrorReporting(Vue, { store, router })

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
